module.exports = __webpack_public_path__ + "img/bi_icon_zy.cd6a9ee3.png";